import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { GYPSUM } from 'HubStyleTokens/colors';
import UpgradeConfigContent from './UpgradeConfigContent';
import ComparePlansLink from './ComparePlansLink';
import { mainBreakpoints } from '../common/ProductInfoContainer';
const HeroBG = styled.div.withConfig({
  displayName: "Ebx632HeroBanner__HeroBG",
  componentId: "sc-1p88t6f-0"
})(["width:100%;z-index:-1;background-color:", ";"], GYPSUM);
const ContentContainer = styled.div.withConfig({
  displayName: "Ebx632HeroBanner__ContentContainer",
  componentId: "sc-1p88t6f-1"
})(["", " padding-bottom:42px;margin-bottom:32px;"], mainBreakpoints);

const Ebx632HeroBanner = ({
  upgradeConfig
}) => {
  return /*#__PURE__*/_jsx(HeroBG, {
    children: /*#__PURE__*/_jsxs(ContentContainer, {
      className: "m-x-auto",
      children: [/*#__PURE__*/_jsx(UpgradeConfigContent, {
        upgradeConfig: upgradeConfig
      }), /*#__PURE__*/_jsx(ComparePlansLink, {})]
    })
  });
};

export default Ebx632HeroBanner;